import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const TopSection = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media print {
    display: flex !important;
    gap: 16px !important;
    margin-top: 16px !important;
  }
`

export const MapPlaceholder = styled.div`
  flex: 1;
  background: ${vimovaTheme.colors.backgroundMuted};
  border-radius: ${vimovaTheme.borderRadius.signature};
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    flex: 1 !important;
    background: ${vimovaTheme.colors.backgroundMuted} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    min-height: 200px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  width: 240px;
  flex-shrink: 0;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 10px !important;
    width: 240px !important;
  }
`

export const StatCard = styled.div`
  background: ${vimovaTheme.colors.backgroundLight};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 12px;

  @media print {
    background: ${vimovaTheme.colors.backgroundLight} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatValue = styled.div<{ $color?: string }>`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 16px;
  color: ${({ $color }) => $color || vimovaTheme.colors.primary};
  margin-top: 4px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 16px !important;
    color: ${({ $color }) => $color || vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatBigValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 22px;
  color: ${vimovaTheme.colors.primary};
  margin-top: 4px;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 22px !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-top: 16px;

  @media print {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 14px !important;
    margin-top: 16px !important;
  }
`

export const ListingCard = styled.div`
  background: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};
  overflow: hidden;
  border: 0.5px solid ${vimovaTheme.colors.border};
  display: flex;
  flex-direction: column;

  @media print {
    background: ${vimovaTheme.colors.white} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    overflow: hidden !important;
    border: 0.5px solid ${vimovaTheme.colors.border} !important;
    display: flex !important;
    flex-direction: column !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingImageWrapper = styled.div`
  position: relative;
`

export const ListingImage = styled.div<{ $imageUrl?: string }>`
  width: 100%;
  height: 110px;
  border-radius: ${vimovaTheme.borderRadius.signature};
  background: ${({ $imageUrl }) =>
    $imageUrl
      ? `url(${$imageUrl}) center/cover no-repeat`
      : vimovaTheme.colors.backgroundMuted};

  @media print {
    height: 110px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    background: ${({ $imageUrl }) =>
      $imageUrl
        ? `url(${$imageUrl}) center/cover no-repeat`
        : vimovaTheme.colors.backgroundMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingImageEditOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  font-family: ${vimovaTheme.fonts.heading};
  font-size: 10px;
  font-weight: ${vimovaTheme.fontWeights.bold};
  color: ${vimovaTheme.colors.white};
  border-radius: ${vimovaTheme.borderRadius.signature};
  z-index: 2;

  *:hover > & {
    opacity: 1;
  }

  @media print {
    display: none !important;
  }
`

export const ListingStatusBadge = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 10px;
  border-radius: 8px;
  background: ${({ $active }) =>
    $active ? vimovaTheme.colors.green : vimovaTheme.colors.textMuted};
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 8px;
  color: ${vimovaTheme.colors.white};

  @media print {
    padding: 2px 10px !important;
    border-radius: 8px !important;
    background: ${({ $active }) =>
      $active
        ? vimovaTheme.colors.green
        : vimovaTheme.colors.textMuted} !important;
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.white} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingContent = styled.div`
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media print {
    padding: 10px 12px 12px !important;
    display: flex !important;
    flex-direction: column !important;
    flex: 1 !important;
  }
`

export const ListingTitle = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: 11px;
  color: ${vimovaTheme.colors.textDark};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: 11px !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingCity = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 9px;
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 2px;

  @media print {
    font-size: 9px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingFeature = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;

  svg {
    flex-shrink: 0;
  }

  @media print {
    display: inline-flex !important;
    align-items: center !important;
    gap: 4px !important;
  }
`

export const ListingFeatures = styled.div`
  display: flex;
  gap: 12px;
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 8px;
  align-items: center;

  @media print {
    display: flex !important;
    gap: 12px !important;
    align-items: center !important;
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingPriceRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: auto;
  padding-top: 8px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: flex-end !important;
    margin-top: auto !important;
    padding-top: 8px !important;
  }
`

export const ListingPrice = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: 15px;
  color: ${vimovaTheme.colors.greenDark};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: 15px !important;
    color: ${vimovaTheme.colors.greenDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ListingPriceSqm = styled.div<{ $visible?: boolean }>`
  font-family: ${vimovaTheme.fonts.body};
  font-size: 8px;
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 1px;
  visibility: ${({ $visible = true }) => ($visible ? 'visible' : 'hidden')};

  @media print {
    font-size: 8px !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    visibility: ${({ $visible = true }) =>
      $visible ? 'visible' : 'hidden'} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
